<template>
  <div class="flex max-w-xl flex-col items-start gap-8">
    <CreditCardIcon class="size-20 text-primary" stroke-width="1.5" />
    <div>
      <h1 class="text-2xl font-semibold">{{ t('title') }}</h1>
      <p class="mt-2 text-base text-gray-600">{{ t('subtitle') }}</p>
    </div>
    <div class="grid w-full gap-8" :class="depositAmount != null ? 'grid-cols-2' : 'grid-cols-1'">
      <LabeledText v-if="depositAmount != null" :label="t('deposit')">
        <span class="text-2xl font-semibold tabular-nums">
          <span v-currency="depositAmount" />
        </span>
      </LabeledText>
      <LabeledText :label="t('outstandingBalance')">
        <span class="text-2xl font-semibold tabular-nums">
          <span v-currency="outstandingBalance" />
        </span>
      </LabeledText>
    </div>
  </div>
</template>

<script setup lang="ts">
import LabeledText from '@/components/LabeledText.vue';
import type { ProcessSessionBookingSummaryDto } from '@carvia/ros-client-types';
import { CreditCardIcon } from 'lucide-vue-next';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  summary: ProcessSessionBookingSummaryDto;
}>();

const { t } = useI18n();

const depositAmount = computed(() => props.summary.depositAmount ?? null);
const outstandingBalance = computed(() => props.summary.outstandingBalance ?? 0);
</script>

<i18n lang="json">
{
  "en": {
    "title": "Deposit & payment",
    "subtitle": "Please deposit the amount with your credit card.",
    "deposit": "Deposit",
    "outstandingBalance": "Outstanding balance"
  },
  "de": {
    "title": "Kaution & Zahlung",
    "subtitle": "Bitte hinterlegen Sie den Betrag mit Ihrer Kreditkarte.",
    "deposit": "Kaution",
    "outstandingBalance": "Offener Betrag"
  },
  "es": {
    "title": "Fianza y pago",
    "subtitle": "Entregue el importe con su tarjeta de crédito.",
    "deposit": "Fianza",
    "outstandingBalance": "Saldo pendiente"
  }
}
</i18n>
